export default __webpack_public_path__ + "static/media/measuring.fb5d6d3a.webm";